import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "tooltip",
  "data-tip": "Configuration warnings, click to see"
}
const _hoisted_2 = { class: "flex flex-row items-end hover:scale-110" }
const _hoisted_3 = {
  key: 0,
  class: "text-sm pl-[1px]"
}

import { useKeyboardStore } from "@/stores";

export default /*@__PURE__*/_defineComponent({
  __name: 'ConfigWarningsIndicator',
  setup(__props) {

const kb = useKeyboardStore();

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      (_unref(kb).warnings.length > 0)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.popupOpen = true))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_Icon, { icon: "bi:exclamation-triangle-fill" }),
                (_unref(kb).warnings.length > 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(kb).warnings.length), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})